import * as React from 'react';
import { Modal } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { ActionButtons } from '../components/ActionButtons.js';
import '@swc/helpers';
import 'classnames';
import { RequiredActionMessage } from '../components/RequiredActionMessage.js';
import { getConfirmationModalLabels } from '../utils/get-confirmation-modal-labels.js';

const ConfirmationModalContainer = ({ lineItems , handleOnAction , handleOnCancel , isLoading , isOpen , onModalClose , validation  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>getConfirmationModalLabels(getFormattedLabel, getLabel, validation, lineItems)
    , [
        getFormattedLabel,
        getLabel,
        validation,
        lineItems
    ]);
    const content = React.useMemo(()=>/*#__PURE__*/ React.createElement(RequiredActionMessage, {
            information: labels.errorMessage,
            action: labels.sanitizationAction
        })
    , [
        labels
    ]);
    const footer = React.useMemo(()=>/*#__PURE__*/ React.createElement(ActionButtons, {
            labels: labels,
            handleOnAction: handleOnAction,
            handleOnCancel: handleOnCancel,
            isDisabled: isLoading
        })
    , [
        handleOnAction,
        handleOnCancel,
        isLoading,
        labels
    ]);
    return /*#__PURE__*/ React.createElement(Modal, {
        children: content,
        className: "confirmation-modal",
        "data-t": "confirmation-modal",
        footer: footer,
        isOpen: isOpen,
        showIcon: true,
        title: labels.title,
        onModalClose: onModalClose
    });
};

export { ConfirmationModalContainer };
//# sourceMappingURL=ConfirmationModalContainer.js.map
